import {
  Avatar,
  Box,
  Divider,
  Flex,
  Heading,
  Text,
  useColorMode,
  Image,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import {
  RiListOrdered2,
  RiLogoutCircleRLine,
  RiUserStarFill,
} from "react-icons/ri";
import {
  FaUsers,
  FaDollarSign,
  FaFileContract,
  FaUserTie,
} from "react-icons/fa";
import { TfiEmail } from "react-icons/tfi";
import { FiUserPlus } from "react-icons/fi";
import { HiOutlineBuildingOffice } from "react-icons/hi2";
import downImage from "../../menu.png";
import upImage from "../../close.png";
import {
  MdOutlineAlternateEmail,
  MdOutlineCampaign,
  MdOutlineDashboardCustomize,
  MdOutlineEmail,
  MdOutlinePersonSearch,
  MdPersonSearch,
} from "react-icons/md";
import GmailAuth from "../../GmailAuth";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FcGoogle } from "react-icons/fc";
import { PiUploadSimple } from "react-icons/pi";
import { RxCaretDown, RxCaretUp, RxHamburgerMenu } from "react-icons/rx";
import { AiOutlineApi } from "react-icons/ai";
import { FaUser } from "react-icons/fa";
import { IoIosMail } from "react-icons/io";
import { TbCameraStar } from "react-icons/tb";
import { useNotification } from "../../services/NotificationContext";
import PremiumFeatureModal from "../Modal/PremiumFeatureModal";
// import { FaFileContract } from 'react-icons/fa';

const NavigationPanel = ({ mainPath }) => {
  const role =
    useSelector((state) => state.role) || localStorage.getItem("Role");
  const isPremium =
    useSelector((state) => state.isPremium) ||
    localStorage.getItem("isPremium");
  const navigate = useNavigate();
  const [isMoreMenuVisible, setIsMoreMenuVisible] = useState(false);
  const [isMainMenuVisible1, setIsMainMenuVisible1] = useState(false);
  const [isMobileView, setisMobileView] = useState(window.innerWidth <= 786);
  const [showScouting, setShowScouting] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(
    JSON.parse(localStorage.getItem("isCollapsed")) || false
  );
  const { totalCount, handleEmailRead, createNotification, getNotifications } =
    useNotification();

  useEffect(() => {
    handleEmailRead();
  }, []);

  useEffect(() => {
    createNotification();
    getNotifications();
  });

  // const response = await createNotification({ message: notificationData });
  useEffect(() => {
    const handleResize = () => {
      setisMobileView(window.innerWidth <= 786);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleCloseToggle = () => {
    setIsMainMenuVisible1(false);
  };

  const handleOpenToggle = () => {
    setIsMainMenuVisible1(true);
  };

  const handleToggleMenu2 = () => {
    setIsMainMenuVisible1(false);
  };
  const handleResetTab = () => {
    localStorage.setItem("TabIndex", 0);
  };
  const location = useLocation();
  const path = location.pathname;

  const { colorMode } = useColorMode();

  const Email = localStorage.getItem("userEmail");

  useEffect(() => {
    setIsMainMenuVisible1(false);
  }, [location.pathname]);

  const handleLogout = () => {
    localStorage.removeItem("userEmail");
    localStorage.removeItem("token");
    localStorage.removeItem("Role");
    window.location.href = "/login";
  };
  return (
    <Box
      className="menu-full menu_style"
      boxShadow={
        colorMode === "light"
          ? `${isCollapsed && !isMobileView ? "#000000" : "base"}`
          : "4px 0px 8px rgba(0, 0, 0, 0.1)"
      }
      display={"flex"}
      //flex={"1"}
      flexDirection={"column"}
      backgroundColor={isCollapsed && !isMobileView ? "#000000" : "transparent"}
      justifyContent={"space-between"}
      height={"100vh"}
      w={isCollapsed ? "60px" : "233px"}
      maxWidth={"233"}
      transition={"width 0.1s ease-in-out"}
    >
      <Box className="menu-mob" marginX={"auto"}>
        <Flex
          className="menu-left"
          m={isCollapsed ? "15px auto" : "15px 20px"}
          flexDirection={"column"}
          alignItems={"center"}
          justifyContent={isCollapsed && "center"}
        >
          {!isMobileView && (
            <Box w={"full"}>
              <div
                className=""
                style={{
                  transform: !isCollapsed && "translateX(-10px)",
                }}
              >
                <RxHamburgerMenu
                  style={{
                    cursor: "pointer",
                  }}
                  color={isCollapsed ? "white" : "black"}
                  onClick={() => {
                    localStorage.setItem(
                      "isCollapsed",
                      JSON.stringify(!isCollapsed)
                    );
                    setIsCollapsed(!isCollapsed);
                  }}
                  size={40}
                />
              </div>
            </Box>
          )}
          {(isMobileView || !isCollapsed) && (
            <>
              <Flex
                direction={{ base: "row", md: "column" }}
                align={{ base: "center", md: "center" }}
                gap={{ base: 4, md: 2 }}
              >
                <Image
                  mt="5px"
                  src="/cm_logo.png"
                  alt={Email}
                  w={{ base: "100px", md: "100%" }} // Smaller on mobile, larger on desktop
                  h={{ base: "30px", md: "100%" }}
                />

                <Box
                  className="name-box"
                  textAlign={{ base: "left", md: "center" }}
                >
                  {/* <Heading size={"md"} mt={"5px"} mb={"2px"} color={"#black"}>
                    Creatives Matter
                  </Heading> */}
                  <Text
                    fontSize={"12px"}
                    display={"flex"}
                    alignItems={"center"}
                    gap={"5px"}
                    color={"gray.500"}
                  >
                    <TfiEmail />
                    {Email}
                  </Text>
                </Box>
              </Flex>
            </>
          )}
        </Flex>
        {(isMobileView || !isCollapsed) && (
          <Divider className="mob-none" borderColor={"green.500"} />
        )}

        <Box
          m={isCollapsed ? "15px auto" : "15px 20px"}
          className="inner_links"
        >
          {isMobileView ? (
            <>
              {/* <Link onClick={handleToggleMenu}>
                                <Flex alignItems={"center"} gap={"10px"} mb={"12px"} display={{ base: 'flex', md: 'none' }}>
                                    <img src={isMainMenuVisible1 ? upImage : downImage} alt="Menu Icon" width={22} height={22} />
                                </Flex>
                            </Link> */}
              {isMainMenuVisible1 ? (
                <div onClick={handleCloseToggle}>
                  <Flex
                    alignItems={"center"}
                    gap={"10px"}
                    mb={"12px"}
                    display={{ base: "flex", md: "none" }}
                  >
                    <img src={upImage} alt="Menu Icon" width={22} height={22} />
                  </Flex>
                </div>
              ) : (
                <div onClick={handleOpenToggle}>
                  <Flex
                    alignItems={"center"}
                    gap={"10px"}
                    mb={"12px"}
                    display={{ base: "flex", md: "none" }}
                  >
                    <img
                      src={downImage}
                      alt="Menu Icon"
                      width={22}
                      height={22}
                    />
                  </Flex>
                </div>
              )}

              <div className="menu-mobile">
                {isMainMenuVisible1 && (
                  <>
                    <Link
                      to={`${mainPath}/dashboard`}
                      className={
                        path === `${mainPath}/dashboard` ? "active" : ""
                      }
                      onClick={handleCloseToggle}
                    >
                      <Flex alignItems={"center"} gap={"10px"} mb={"12px"}>
                        <MdOutlineDashboardCustomize
                          size={22}
                          className={
                            path === `${mainPath}/dashboard`
                              ? "active_icon"
                              : "inactive_icon"
                          }
                        />
                        <Text>Dashboard</Text>
                      </Flex>
                    </Link>

                    {role !== "Influencer" && (
                      <Link
                        to={`${mainPath}/Inbox`}
                        className={path === `${mainPath}/Inbox` ? "active" : ""}
                        onClick={handleCloseToggle}
                      >
                        <Flex alignItems={"center"} gap={"10px"} mb={"12px"}>
                          <IoIosMail
                            size={22}
                            className={
                              path === `${mainPath}/Inbox`
                                ? "active_icon"
                                : "inactive_icon"
                            }
                          />
                          <Text style={{ position: "relative" }}>
                            Inbox
                            {totalCount !== 0 && (
                              <span
                                className="notice"
                                style={{
                                  position: "absolute",
                                  left: "50px",
                                  top: "0px",
                                  backgroundColor: "rgb(248, 9, 9)",
                                  color: "white",
                                  borderRadius: "10%",
                                  fontSize: "15px",
                                  height: "24px",
                                  width: "35px",
                                }}
                              >
                                {totalCount}
                              </span>
                            )}
                          </Text>
                        </Flex>
                      </Link>
                    )}

                    {role !== "Influencer" ? (
                      <Link
                        to={`${mainPath}/deals?page=1`}
                        className={path === `${mainPath}/deals` ? "active" : ""}
                        onClick={handleCloseToggle}
                      >
                        <Flex alignItems={"center"} gap={"10px"} mb={"12px"}>
                          <FaDollarSign
                            size={22}
                            className={
                              path === `${mainPath}/deals`
                                ? "active_icon"
                                : "inactive_icon"
                            }
                          />
                          <Text>Deals</Text>
                        </Flex>
                      </Link>
                    ) : (
                      <Link
                        to={`${mainPath}/All_Deals?page=1`}
                        className={
                          path === `${mainPath}/All_Deals` ? "active" : ""
                        }
                        onClick={handleCloseToggle}
                      >
                        <Flex alignItems={"center"} gap={"10px"} mb={"8px"}>
                          <FaDollarSign
                            size={20}
                            className={
                              path === `${mainPath}/All_Deals`
                                ? "active_icon"
                                : "inactive_icon"
                            }
                          />
                          <Text fontSize={15}>Deals</Text>
                        </Flex>
                      </Link>
                    )}

                    <NavLink
                      to={`${mainPath}/Outreach`}
                      onClick={handleCloseToggle}
                    >
                      <Flex alignItems={"center"} gap={"10px"} mb={"12px"}>
                        <MdOutlineCampaign
                          size={22}
                          className={
                            path === `${mainPath}/Outreach`
                              ? "active_icon"
                              : "inactive_icon"
                          }
                        />
                        <Text>Outreach</Text>
                      </Flex>
                    </NavLink>

                    {role !== "Influencer" && (
                      <NavLink
                        to={`${mainPath}/scouting`}
                        onClick={handleCloseToggle}
                      >
                        <Flex alignItems={"center"} gap={"10px"} mb={"12px"}>
                          <TbCameraStar
                            size={22}
                            className={
                              path === `${mainPath}/scouting`
                                ? "active_icon"
                                : "inactive_icon"
                            }
                          />
                          <Text>Scouting</Text>
                        </Flex>
                      </NavLink>
                    )}

                    {role === "Influencer" && (
                      <NavLink
                        to={`${mainPath}/Contract_Review`}
                        onClick={handleCloseToggle}
                      >
                        <Flex alignItems={"center"} gap={"10px"} mb={"12px"}>
                          <FaFileContract
                            size={22}
                            className={
                              path === `${mainPath}/Contract_Review`
                                ? "active_icon"
                                : "inactive_icon"
                            }
                          />
                          <Text>Contracts</Text>
                        </Flex>
                      </NavLink>
                    )}

                    {role !== "Influencer" && (
                      <div
                        onClick={() => setIsMoreMenuVisible(!isMoreMenuVisible)}
                      >
                        <Flex alignItems={"center"} gap={"10px"}>
                          {!isMoreMenuVisible && <RxCaretDown size={22} />}
                          <Text>{!isMoreMenuVisible && "More"}</Text>
                        </Flex>
                      </div>
                    )}
                    {role === "Influencer" && (
                      <NavLink
                        to={`${mainPath}/sequences`}
                        onClick={handleCloseToggle}
                      >
                        <Flex alignItems={"center"} gap={"10px"} mb={"12px"}>
                          <RiListOrdered2
                            size={22}
                            className={
                              path === `${mainPath}/sequences`
                                ? "active_icon"
                                : "inactive_icon"
                            }
                          />
                          <Text>Sequences</Text>
                        </Flex>
                      </NavLink>
                    )}
                    {role === "Influencer" && (
                      <NavLink
                        to={`${mainPath}/company`}
                        onClick={handleCloseToggle}
                      >
                        <Flex alignItems={"center"} gap={"10px"} mb={"12px"}>
                          <HiOutlineBuildingOffice
                            size={22}
                            className={
                              path === `${mainPath}/company`
                                ? "active_icon"
                                : "inactive_icon"
                            }
                          />
                          <Text>Company</Text>
                        </Flex>
                      </NavLink>
                    )}
                    {role === "Influencer" && (
                      <NavLink
                        to={`${mainPath}/profile`}
                        onClick={handleCloseToggle}
                      >
                        <Flex alignItems={"center"} gap={"10px"} mb={"12px"}>
                          <FaUser
                            size={22}
                            className={
                              path === `${mainPath}/profile`
                                ? "active_icon"
                                : "inactive_icon"
                            }
                          />
                          <Text>Profile</Text>
                        </Flex>
                      </NavLink>
                    )}

                    {isMoreMenuVisible && (
                      <>
                        {
                          <>
                            <NavLink
                              to={`${mainPath}/Contract_Review`}
                              onClick={handleCloseToggle}
                            >
                              <Flex
                                alignItems={"center"}
                                gap={"10px"}
                                mb={"12px"}
                              >
                                <FaFileContract
                                  size={22}
                                  className={
                                    path === `${mainPath}/Contract_Review`
                                      ? "active_icon"
                                      : "inactive_icon"
                                  }
                                />
                                <Text>Contracts</Text>
                              </Flex>
                            </NavLink>
                            <NavLink
                              to={`${mainPath}/sequences`}
                              onClick={handleCloseToggle}
                            >
                              <Flex
                                alignItems={"center"}
                                gap={"10px"}
                                mb={"12px"}
                              >
                                <RiListOrdered2
                                  size={22}
                                  className={
                                    path === `${mainPath}/sequences`
                                      ? "active_icon"
                                      : "inactive_icon"
                                  }
                                />
                                <Text>Sequences</Text>
                              </Flex>
                            </NavLink>
                          </>
                        }

                        <NavLink
                          to={`${mainPath}/company`}
                          onClick={handleCloseToggle}
                        >
                          <Flex alignItems={"center"} gap={"10px"} mb={"12px"}>
                            <HiOutlineBuildingOffice
                              size={22}
                              className={
                                path === `${mainPath}/company`
                                  ? "active_icon"
                                  : "inactive_icon"
                              }
                            />
                            <Text>Company</Text>
                          </Flex>
                        </NavLink>

                        {role !== "Influencer" && (
                          <NavLink
                            to={`${mainPath}/prospect`}
                            onClick={handleCloseToggle}
                          >
                            <Flex
                              alignItems={"center"}
                              gap={"10px"}
                              mb={"12px"}
                            >
                              <FaUserTie
                                size={22}
                                className={
                                  path === `${mainPath}/prospect`
                                    ? "active_icon"
                                    : "inactive_icon"
                                }
                              />
                              <Text>Prospect</Text>
                            </Flex>
                          </NavLink>
                        )}

                        {role !== "Influencer" && (
                          <NavLink
                            to={`${mainPath}/influencer`}
                            onClick={handleCloseToggle}
                          >
                            <Flex
                              alignItems={"center"}
                              gap={"10px"}
                              mb={"12px"}
                            >
                              <RiUserStarFill
                                size={22}
                                className={
                                  path === `${mainPath}/influencer`
                                    ? "active_icon"
                                    : "inactive_icon"
                                }
                              />
                              <Text>Influencer</Text>
                            </Flex>
                          </NavLink>
                        )}

                        {role !== "Influencer" &&
                          role !== "Creator Manager" && (
                            <>
                              <NavLink
                                to={`${mainPath}/users`}
                                onClick={handleCloseToggle}
                              >
                                <Flex
                                  alignItems={"center"}
                                  gap={"10px"}
                                  mb={"12px"}
                                >
                                  <FaUsers
                                    size={22}
                                    className={
                                      path === `${mainPath}/users`
                                        ? "active_icon"
                                        : "inactive_icon"
                                    }
                                  />
                                  <Text>Users</Text>
                                </Flex>
                              </NavLink>

                              <NavLink
                                to={`${mainPath}/accounts`}
                                onClick={handleCloseToggle}
                              >
                                <Flex
                                  alignItems={"center"}
                                  gap={"10px"}
                                  mb={"12px"}
                                >
                                  <MdOutlineEmail
                                    size={22}
                                    className={
                                      path === `${mainPath}/accounts`
                                        ? "active_icon"
                                        : "inactive_icon"
                                    }
                                  />
                                  <Text>Accounts</Text>
                                </Flex>
                              </NavLink>

                              <NavLink
                                to={`${mainPath}/uploader`}
                                onClick={handleCloseToggle}
                              >
                                <Flex
                                  alignItems={"center"}
                                  gap={"10px"}
                                  mb={"12px"}
                                >
                                  <PiUploadSimple
                                    size={22}
                                    className={
                                      path === `${mainPath}/uploader`
                                        ? "active_icon"
                                        : "inactive_icon"
                                    }
                                  />
                                  <Text>Import</Text>
                                </Flex>
                              </NavLink>
                            </>
                          )}
                      </>
                    )}

                    {role !== "Influencer" && (
                      <div
                        onClick={() => setIsMoreMenuVisible(!isMoreMenuVisible)}
                      >
                        <Flex alignItems={"center"} gap={"10px"}>
                          {isMoreMenuVisible && <RxCaretUp size={22} />}
                          <Text>{isMoreMenuVisible && "Less"}</Text>
                        </Flex>
                      </div>
                    )}
                  </>
                )}
              </div>
            </>
          ) : (
            <>
              <Link
                to={`${mainPath}/dashboard`}
                className={path === `${mainPath}/dashboard` ? "active" : ""}
              >
                <Flex
                  justifyContent={isCollapsed && "center"}
                  alignItems={"center"}
                  gap={"10px"}
                  mb={"8px"}
                >
                  <MdOutlineDashboardCustomize
                    size={isCollapsed ? 32 : 20}
                    className={
                      path === `${mainPath}/dashboard`
                        ? "active_icon"
                        : isCollapsed
                        ? "collapsed_inactive_icon"
                        : "inactive_icon"
                    }
                    style={{
                      transition: "all 0.1s ease",
                    }}
                  />
                  {!isCollapsed && <Text fontSize={15}>Dashboard</Text>}
                </Flex>
              </Link>
              {role !== "Influencer" && (
                <Link
                  to={`${mainPath}/Inbox`}
                  className={path === `${mainPath}/Inbox` ? "active" : ""}
                >
                  <Flex
                    position={"relative"}
                    justifyContent={isCollapsed && "center"}
                    alignItems={"center"}
                    gap={"10px"}
                    mb={"8px"}
                  >
                    <IoIosMail
                      size={isCollapsed ? 32 : 20}
                      className={
                        path === `${mainPath}/Inbox`
                          ? "active_icon"
                          : isCollapsed
                          ? "collapsed_inactive_icon"
                          : "inactive_icon"
                      }
                      style={{ transition: "all 0.1s ease" }}
                    />
                    {isCollapsed && totalCount !== 0 && (
                      <span
                        className="notice"
                        style={{
                          position: "absolute",
                          backgroundColor: "rgb(248, 9, 9)",
                          top: "-5px",
                          right: "-7px",
                          color: "white",
                          fontSize: "14px",
                          height: "24px",
                          width: "24px",
                          borderRadius: "100%",
                        }}
                      >
                        {totalCount > 99 ? "99+" : totalCount}
                      </span>
                    )}
                    {!isCollapsed && (
                      <Text
                        fontSize={15}
                        onClick={handleResetTab}
                        style={{ display: "flex", position: "relative" }}
                      >
                        Inbox
                        {totalCount !== 0 && (
                          <span
                            className="notice"
                            style={{
                              position: "absolute",
                              left: "50px",
                              top: "2px",
                              backgroundColor: "rgb(248, 9, 9)",
                              color: "white",
                              borderRadius: "10%",
                              fontSize: "15px",
                              height: "24px",
                              width: "35px",
                            }}
                          >
                            {totalCount}
                          </span>
                        )}
                      </Text>
                    )}
                  </Flex>
                </Link>
              )}

              {role !== "Influencer" ? (
                <Link
                  to={`${mainPath}/deals?page=1`}
                  className={path === `${mainPath}/deals` ? "active" : ""}
                >
                  <Flex
                    justifyContent={isCollapsed && "center"}
                    alignItems={"center"}
                    gap={"10px"}
                    mb={"8px"}
                  >
                    <FaDollarSign
                      size={isCollapsed ? 32 : 20}
                      className={
                        path === `${mainPath}/deals`
                          ? "active_icon"
                          : isCollapsed
                          ? "collapsed_inactive_icon"
                          : "inactive_icon"
                      }
                      style={{ transition: "all 0.1s ease" }}
                    />
                    {!isCollapsed && <Text fontSize={15}>Deals</Text>}
                  </Flex>
                </Link>
              ) : (
                <Link
                  to={`${mainPath}/All_Deals?page=1`}
                  className={path === `${mainPath}/All_Deals` ? "active" : ""}
                >
                  <Flex
                    justifyContent={isCollapsed && "center"}
                    alignItems={"center"}
                    gap={"10px"}
                    mb={"8px"}
                  >
                    <FaDollarSign
                      size={isCollapsed ? 32 : 20}
                      className={
                        path === `${mainPath}/All_Deals`
                          ? "active_icon"
                          : isCollapsed
                          ? "collapsed_inactive_icon"
                          : "inactive_icon"
                      }
                      style={{ transition: "all 0.1s ease" }}
                    />
                    {!isCollapsed && <Text fontSize={15}>Deals</Text>}
                  </Flex>
                </Link>
              )}

              <NavLink to={`${mainPath}/Outreach`}>
                <Flex
                  justifyContent={isCollapsed && "center"}
                  alignItems={"center"}
                  gap={"10px"}
                  mb={"8px"}
                >
                  <MdOutlineCampaign
                    size={isCollapsed ? 32 : 20}
                    className={
                      path === `${mainPath}/Outreach`
                        ? "active_icon"
                        : isCollapsed
                        ? "collapsed_inactive_icon"
                        : "inactive_icon"
                    }
                    style={{ transition: "all 0.1s ease" }}
                  />
                  {!isCollapsed && <Text fontSize={15}>Outreach</Text>}
                </Flex>
              </NavLink>

              {role !== "Influencer" && (
                <NavLink to={`${mainPath}/scouting`}>
                  <Flex
                    justifyContent={isCollapsed && "center"}
                    alignItems={"center"}
                    gap={"10px"}
                    mb={"8px"}
                  >
                    <TbCameraStar
                      size={isCollapsed ? 32 : 20}
                      className={
                        path === `${mainPath}/scouting`
                          ? "active_icon"
                          : isCollapsed
                          ? "collapsed_inactive_icon"
                          : "inactive_icon"
                      }
                      style={{ transition: "all 0.1s ease" }}
                    />
                    {!isCollapsed && <Text fontSize={15}>Scouting</Text>}
                  </Flex>
                </NavLink>
              )}

              <NavLink to={`${mainPath}/Contract_Review`}>
                <Flex
                  justifyContent={isCollapsed && "center"}
                  alignItems={"center"}
                  gap={"10px"}
                  mb={"8px"}
                >
                  <FaFileContract
                    size={isCollapsed ? 32 : 20}
                    className={
                      path === `${mainPath}/Contract_Review`
                        ? "active_icon"
                        : isCollapsed
                        ? "collapsed_inactive_icon"
                        : "inactive_icon"
                    }
                    style={{ transition: "all 0.1s ease" }}
                  />
                  {!isCollapsed && <Text fontSize={15}>Contracts</Text>}
                </Flex>
              </NavLink>

              {
                <NavLink to={`${mainPath}/sequences`}>
                  <Flex
                    justifyContent={isCollapsed && "center"}
                    alignItems={"center"}
                    gap={"10px"}
                    mb={"8px"}
                  >
                    <RiListOrdered2
                      size={isCollapsed ? 32 : 20}
                      className={
                        path === `${mainPath}/sequences`
                          ? "active_icon"
                          : isCollapsed
                          ? "collapsed_inactive_icon"
                          : "inactive_icon"
                      }
                      style={{ transition: "all 0.1s ease" }}
                    />
                    {!isCollapsed && <Text fontSize={15}>Sequences</Text>}
                  </Flex>
                </NavLink>
              }

              <NavLink to={`${mainPath}/company`}>
                <Flex
                  justifyContent={isCollapsed && "center"}
                  alignItems={"center"}
                  gap={"10px"}
                  mb={"8px"}
                >
                  <HiOutlineBuildingOffice
                    size={isCollapsed ? 32 : 20}
                    className={
                      path === `${mainPath}/company`
                        ? "active_icon"
                        : isCollapsed
                        ? "collapsed_inactive_icon"
                        : "inactive_icon"
                    }
                    style={{ transition: "all 0.1s ease" }}
                  />
                  {!isCollapsed && <Text fontSize={15}>Company</Text>}
                </Flex>
              </NavLink>

              {role !== "Influencer" && (
                <NavLink to={`${mainPath}/prospect`}>
                  <Flex
                    justifyContent={isCollapsed && "center"}
                    alignItems={"center"}
                    gap={"10px"}
                    mb={"8px"}
                  >
                    <FaUserTie
                      size={isCollapsed ? 32 : 20}
                      className={
                        path === `${mainPath}/prospect`
                          ? "active_icon"
                          : isCollapsed
                          ? "collapsed_inactive_icon"
                          : "inactive_icon"
                      }
                      style={{ transition: "all 0.1s ease" }}
                    />
                    {!isCollapsed && <Text fontSize={15}>Prospect</Text>}
                  </Flex>
                </NavLink>
              )}

              {role !== "Influencer" && (
                <NavLink to={`${mainPath}/influencer`}>
                  <Flex
                    justifyContent={isCollapsed && "center"}
                    alignItems={"center"}
                    gap={"10px"}
                    mb={"8px"}
                  >
                    <RiUserStarFill
                      size={isCollapsed ? 32 : 20}
                      className={
                        path === `${mainPath}/influencer`
                          ? "active_icon"
                          : isCollapsed
                          ? "collapsed_inactive_icon"
                          : "inactive_icon"
                      }
                      style={{ transition: "all 0.1s ease" }}
                    />
                    {!isCollapsed && <Text fontSize={15}>Influencer</Text>}
                  </Flex>
                </NavLink>
              )}

              {role !== "Influencer" && role !== "Creator Manager" && (
                <NavLink to={`${mainPath}/users`}>
                  <Flex
                    justifyContent={isCollapsed && "center"}
                    alignItems={"center"}
                    gap={"10px"}
                    mb={"8px"}
                  >
                    <FaUsers
                      size={isCollapsed ? 32 : 20}
                      className={
                        path === `${mainPath}/users`
                          ? "active_icon"
                          : isCollapsed
                          ? "collapsed_inactive_icon"
                          : "inactive_icon"
                      }
                      style={{ transition: "all 0.1s ease" }}
                    />
                    {!isCollapsed && <Text fontSize={15}>Users</Text>}
                  </Flex>
                </NavLink>
              )}

              {role !== "Influencer" && role !== "Creator Manager" && (
                <NavLink to={`${mainPath}/accounts`}>
                  <Flex
                    justifyContent={isCollapsed && "center"}
                    alignItems={"center"}
                    gap={"10px"}
                    mb={"8px"}
                  >
                    <MdOutlineEmail
                      size={isCollapsed ? 32 : 20}
                      className={
                        path === `${mainPath}/accounts`
                          ? "active_icon"
                          : isCollapsed
                          ? "collapsed_inactive_icon"
                          : "inactive_icon"
                      }
                      style={{ transition: "all 0.1s ease" }}
                    />
                    {!isCollapsed && <Text fontSize={15}>Accounts</Text>}
                  </Flex>
                </NavLink>
              )}

              {role !== "Influencer" && role !== "Creator Manager" && (
                <NavLink to={`${mainPath}/uploader`}>
                  <Flex
                    justifyContent={isCollapsed && "center"}
                    alignItems={"center"}
                    gap={"10px"}
                    mb={"8px"}
                  >
                    <PiUploadSimple
                      size={isCollapsed ? 32 : 20}
                      className={
                        path === `${mainPath}/uploader`
                          ? "active_icon"
                          : isCollapsed
                          ? "collapsed_inactive_icon"
                          : "inactive_icon"
                      }
                      style={{ transition: "all 0.1s ease" }}
                    />
                    {!isCollapsed && <Text fontSize={15}>Import</Text>}
                  </Flex>
                </NavLink>
              )}

              {role === "Influencer" && (
                <NavLink to={`${mainPath}/profile`}>
                  <Flex
                    justifyContent={isCollapsed && "center"}
                    alignItems={"center"}
                    gap={"10px"}
                    mb={"8px"}
                  >
                    <FaUser
                      size={isCollapsed ? 32 : 20}
                      className={
                        path === `${mainPath}/profile`
                          ? "active_icon"
                          : isCollapsed
                          ? "collapsed_inactive_icon"
                          : "inactive_icon"
                      }
                      style={{ transition: "all 0.1s ease" }}
                    />
                    {!isCollapsed && <Text fontSize={15}>Profile</Text>}
                  </Flex>
                </NavLink>
              )}
            </>
          )}
        </Box>
      </Box>
      <Box className="menu_links_list">
        {(!isCollapsed || isMobileView) && (
          <Divider className="mob-none" borderColor={"green.500"} />
        )}
        <Box className="mob-none" m={isCollapsed ? "15px auto" : "15px 20px"}>
          {/* <Flex alignItems={"center"} gap={"10px"} my={2} >
                        <GmailAuth/>
                    </Flex> */}

          <Link to="/login">
            <Flex
              justifyContent={isCollapsed && "center"}
              alignItems={"center"}
              gap={"10px"}
              onClick={handleLogout}
            >
              <RiLogoutCircleRLine
                size={isCollapsed ? 28 : 20}
                color={isCollapsed ? "#E2E8F0" : "#1A202C"}
              />
              {!isCollapsed && <Text fontSize={15}>Logout</Text>}
            </Flex>
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default NavigationPanel;
